<template>
    <b-form class="form-horizontal bundle">
        <b-alert show variant="warning">
            Reminders will be created based on each item's actions. If an item
            does not have actions, a reminder will be created based on the
            selection below.
        </b-alert>
        <b-form-group label-for="type" label="Type:" label-cols="3">
            <b-form-select
                v-model="data.reminderType"
                value-field="value"
                name="type"
                class="text-capitalize"
            >
                <b-form-select-option v-if="checkType(1)" :value="1"
                    >Email</b-form-select-option
                >
                <b-form-select-option v-if="checkType(2)" :value="2"
                    >Phone</b-form-select-option
                >
                <b-form-select-option v-if="checkType(3)" :value="3"
                    >Mail</b-form-select-option
                >
                <b-form-select-option v-if="checkType(5)" :value="5"
                    >SMS (Text)</b-form-select-option
                >
                <b-form-select-option :value="4"
                    >No Reminder</b-form-select-option
                >
            </b-form-select>
        </b-form-group>

        <b-form-group
            v-if="data.reminderType == 1 || data.reminderType == 5"
            label-for="send"
            label="Send:"
            label-cols="3"
        >
            <div class="w-25 float-left">
                <b-form-input
                    id="send"
                    v-model="data.reminderSend"
                    :class="{ 'border-danger': errors.has('send') }"
                    v-validate="'required'"
                    name="send"
                ></b-form-input>
            </div>

            <div class="w-25 send-selections">
                <b-form-select
                    v-model="data.reminderPeriod"
                    :options="timePeriodSelections"
                    value-field="value"
                    text-field="text"
                    name="time-period"
                ></b-form-select>
            </div>

            <div class="w-50 send-selections">
                <b-form-select
                    v-model="data.reminderSendOption"
                    :options="sendOptionSelections"
                    value-field="value"
                    text-field="text"
                    name="send-option"
                ></b-form-select>
            </div>
        </b-form-group>
        <b-form-group label-for="note" label="Notes:" label-cols="3">
            <editable v-model="data.note" placeholder="Note" name="note" />
        </b-form-group>
    </b-form>
</template>
<style type="text/css" lang="scss">
.send-selections {
    padding-left: 7px;
    float: left;

    select {
        height: 30px;
        padding: 4px 6px;
    }
}
</style>
<script type="text/javascript">
import { isEmpty } from "lodash";
import Reminders from "@/services/client-reminders";
import Editable from "@/components/elements/editable-textarea";

export default {
    components: { Editable },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            typeOptions: [],
            timePeriodSelections: [
                { value: 4, text: "Day(s)" },
                { value: 5, text: "Week(s)" },
                { value: 6, text: "Month(s)" },
                { value: 7, text: "Year(s)" }
            ],
            sendOptionSelections: [
                { value: 1, text: "Before Due" },
                { value: 2, text: "After Due" }
            ]
        };
    },
    computed: {},
    watch: {
        "data.reminderType"(value) {
            if (value == 1 || value == 5) {
                this.data.reminderPeriod = 4;
                this.data.reminderSend = 2;
                this.data.reminderSendOption = 1;
            } else {
                this.data.reminderPeriod = null;
                this.data.reminderSend = null;
                this.data.reminderSendOption = null;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getType();

            if (this.showPatient && _.isEmpty(this.reminder)) {
                this.getPatients();
            }

            if (this.reminder) {
                this.setDetails(_.clone(this.reminder));
                this.setDisplayGiven();
                this.getInventoryDueOptions();
            } else {
                this.dateGiven = this._now().toFormat(this._dateFormat);
            }
        });
    },
    methods: {
        getType() {
            let self = this;
            if (self.data.patients.length == 1) {
                let patientId = this.data.patients[0];
                if (typeof patientId === "object") {
                    patientId = patientId.id;
                }

                Reminders.filterReminderTypeByPatient(patientId).then(
                    response => {
                        self.typeOptions = response.resources.selected_options;
                        if (!isEmpty(response.resources.selected_options)) {
                            self.data.reminderType =
                                response.resources.selected_options[0];
                        } else {
                            self.data.reminderType =
                                response.resources.selected_type || 4;
                        }
                    }
                );
            } else {
                Reminders.getReminderType(
                    self.data.clientId,
                    self.data.reminderType
                ).then(response => {
                    self.typeOptions = response.selected_options;
                    if (!isEmpty(response.selected_options)) {
                        self.data.reminderType = response.selected_options[0];
                    } else {
                        self.data.reminderType = response.selected_type || 4;
                    }
                });
            }
        },

        checkType(typeId) {
            let type = _.find(this.typeOptions, function (o) {
                return Number(o) === Number(typeId);
            });
            return typeof type !== "undefined";
        }
    }
};
</script>
